import { RTEToolbarButton } from '../components/StyledTextToolbarButton';
import { useEditorUIContext } from '../contexts/EditorUIContext';
import { TextColorIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ToggleFormattingTray() {
  const {
    showFormattingTray,
    setShowFormattingTray
  } = useEditorUIContext();
  return /*#__PURE__*/_jsx(RTEToolbarButton, {
    "data-test-id": "formatting-tray",
    onClick: () => setShowFormattingTray(!showFormattingTray),
    selected: showFormattingTray,
    children: /*#__PURE__*/_jsx(TextColorIcon, {
      color: "fill-accent-neutral-default"
    })
  });
}